import { CouponErrorFields } from 'components/coupon/couponCreation/CouponHandleError';
import { COUPON_CODE_TYPE, COUPON_REDEMPTION_METHOD, COUPON_SET_MEDIUM, COUPON_SET_TYPES, COUPON_TYPES } from 'config/CustomEnums';
import { VALID_PERIOD_TYPE } from 'models/CreateCouponModel';
import { getCouponSetMedium } from '../campaignStreamline/CreateCampaignCouponPageConfig';
import { BASE_COUPON_PAGE_ANCHOR_KEY } from 'config/PageAnchorConfig/CampaignAnchorConfig';


function firstStepValidate({ getValues, setError }) {
  return true;
}

export const couponBaseInfoValidate = ({ getValues, prefix = "", type = COUPON_TYPES.NORMAL }) => {
  const [
    name,
    coverPhoto,
    shouldUseInStore,
    customerStoreSelectionBehavior,
  ] = getValues([
    `${prefix}translations.en.name`,
    `${prefix}translations.en.coverPhoto`,
    `${prefix}shouldBeUsedInStores`,
    `${prefix}customerStoreSelectionBehavior`,
  ]);
  const errorList = [];

  if (!name || name.length > 200) {
    errorList.push({
      sectionKey: BASE_COUPON_PAGE_ANCHOR_KEY.couponGeneral.sectionKey,
      name: `${prefix}translations.en.name`,
      message: CouponErrorFields.generalName.message,
    });
  }
  if (!coverPhoto) {
    errorList.push({
      sectionKey: BASE_COUPON_PAGE_ANCHOR_KEY.couponKeyVisual.sectionKey,
      name: `${prefix}translations.en.coverPhoto`,
      message: CouponErrorFields.coverPhotoEmpty.message,
    });
  }
  if (type === COUPON_TYPES.NORMAL && shouldUseInStore) {
    if (!customerStoreSelectionBehavior) {
      errorList.push({
        sectionKey: BASE_COUPON_PAGE_ANCHOR_KEY.applicableStores.sectionKey,
        name: `${prefix}customerStoreSelectionBehavior`,
        message: CouponErrorFields.customerStoreSelectionBehavior.message,
      });
    }
  }
  return errorList
}

const onlineCouponValidate = ({
  getValues,
  prefix = "",
}) => {
  const [
    onlineCouponSetType,
    onlineFormats,
    onlineCouponCodeType,
    onlineGenericCode,
  ] = getValues([
    `${prefix}onlineCouponSetType`,
    `${prefix}onlineFormats`,
    `${prefix}onlineCouponCodeType`,
    `${prefix}onlineGenericCode`,
  ]);
  let errorList = []
  if (onlineCouponSetType === COUPON_SET_TYPES.IMPORT_EXISTING_COUPON) {
    if (onlineFormats === null || onlineFormats === undefined) {
      errorList.push({
        sectionKey: BASE_COUPON_PAGE_ANCHOR_KEY.couponProperties.sectionKey,
        name: `${prefix}onlineFormats`,
        message: 'Please select code formart.',
      });
    }

    if (onlineCouponCodeType === null || onlineCouponCodeType === undefined) {
      errorList.push({
        sectionKey: BASE_COUPON_PAGE_ANCHOR_KEY.couponProperties.sectionKey,
        name: `${prefix}onlineCouponCodeType`,
        message: 'Please select coupon code type.',
      });
    }

    if (
      onlineCouponCodeType === COUPON_CODE_TYPE.GENERIC &&
      (onlineGenericCode === null ||
        onlineGenericCode === undefined ||
        !onlineGenericCode)
    ) {
      errorList.push({
        sectionKey: BASE_COUPON_PAGE_ANCHOR_KEY.couponProperties.sectionKey,
        name: `${prefix}onlineGenericCode`,
        message: 'Please input Generic code.',
      });
    }
  }
  return errorList
};

const offlineCouponValidate = ({
  getValues,
  prefix = "",
}) => {
  let errorList = []
  const [
    offlineCouponSetType,
    offlineFormats,
    offlineCouponCodeType,
    offlineGenericCode,
    offlineRedemptionMethod,
  ] = getValues([
    `${prefix}offlineCouponSetType`,
    `${prefix}offlineFormats`,
    `${prefix}offlineCouponCodeType`,
    `${prefix}offlineGenericCode`,
    `${prefix}offlineRedemptionMethod`,
  ]);

  if (offlineCouponSetType === COUPON_SET_TYPES.IMPORT_EXISTING_COUPON) {
    if (
      offlineRedemptionMethod !==
      COUPON_REDEMPTION_METHOD.USERS_COPY_THE_DISCOUNT_CODE
    ) {
      if (offlineFormats === null || offlineFormats === undefined) {
        errorList.push({
          sectionKey: BASE_COUPON_PAGE_ANCHOR_KEY.couponProperties.sectionKey,
          name: `${prefix}offlineFormats`,
          message: 'Please select code formart.',
        });
      }
    }

    if (
      offlineCouponCodeType === null ||
      offlineCouponCodeType === undefined
    ) {
      errorList.push({
        sectionKey: BASE_COUPON_PAGE_ANCHOR_KEY.couponProperties.sectionKey,
        name: `${prefix}offlineCouponCodeType`,
        message: 'Please select coupon code type.',
      });
    }

    if (
      offlineCouponCodeType === COUPON_CODE_TYPE.GENERIC &&
      (offlineGenericCode === null ||
        offlineGenericCode === undefined ||
        !offlineGenericCode)
    ) {
      errorList.push({
        sectionKey: BASE_COUPON_PAGE_ANCHOR_KEY.couponProperties.sectionKey,
        name: `${prefix}offlineGenericCode`,
        message: 'Please input Generic code.',
      });
    }
  }
  return errorList
};

const onlineAndOfflineValidate = ({
  getValues,
  prefix = "",
}) => {
  let errorList = []
  const [
    offlineCouponSetType,
    onlineCouponSetType,
    onlineAndOfflineCouponCodeType,
    onlineAndOfflineFormats,
    onlineAndOfflineGenericCode,
  ] = getValues([
    `${prefix}offlineCouponSetType`,
    `${prefix}onlineCouponSetType`,
    `${prefix}onlineAndOfflineCouponCodeType`,
    `${prefix}onlineAndOfflineFormats`,
    `${prefix}onlineAndOfflineGenericCode`,
  ]);

  if (
    offlineCouponSetType === COUPON_SET_TYPES.IMPORT_EXISTING_COUPON &&
    onlineCouponSetType === COUPON_SET_TYPES.IMPORT_EXISTING_COUPON
  ) {
    if (
      onlineAndOfflineFormats === null ||
      onlineAndOfflineFormats === undefined
    ) {
      errorList.push({
        sectionKey: BASE_COUPON_PAGE_ANCHOR_KEY.couponProperties.sectionKey,
        name: `${prefix}onlineAndOfflineFormats`,
        message: 'Please select code formart.',
      });
    }

    if (
      onlineAndOfflineCouponCodeType === null ||
      onlineAndOfflineCouponCodeType === undefined
    ) {
      errorList.push({
        sectionKey: BASE_COUPON_PAGE_ANCHOR_KEY.couponProperties.sectionKey,
        name: `${prefix}onlineAndOfflineCouponCodeType`,
        message: 'Please select coupon code type.',
      });
    }

    if (
      onlineAndOfflineCouponCodeType === COUPON_CODE_TYPE.GENERIC &&
      (onlineAndOfflineGenericCode === null ||
        onlineAndOfflineGenericCode === undefined ||
        !onlineAndOfflineGenericCode)
    ) {
      errorList.push({
        sectionKey: BASE_COUPON_PAGE_ANCHOR_KEY.couponProperties.sectionKey,
        name: `${prefix}onlineAndOfflineGenericCode`,
        message: 'Please input Generic code.',
      });
    }
  } else if (
    onlineCouponSetType === COUPON_SET_TYPES.IMPORT_EXISTING_COUPON
  ) {
    errorList = [...errorList, ...onlineCouponValidate({ getValues, prefix })]
  } else {
    errorList = [...errorList, ...offlineCouponValidate({ getValues, prefix })]
  }
  return errorList
};

export const couponCodeValidate = ({
  getValues,
  mediumType,
  prefix = "",
}) => {
  const [
    isDifferentCodeForOnlineOffline,
    validPeriodType,
    numberOfDaysToExpireAfterAcquisition,
    absoluteEffectiveDate,
    absoluteExpiryDate,
  ] = getValues([
    `${prefix}isDifferentCodeForOnlineOffline`,
    `${prefix}validPeriodType`,
    `${prefix}numberOfDaysToExpireAfterAcquisition`,
    `${prefix}absoluteEffectiveDate`,
    `${prefix}absoluteExpiryDate`,
  ]);

  let errorList = [];

  if (
    validPeriodType === VALID_PERIOD_TYPE.ABSOLUTE &&
    absoluteExpiryDate <= absoluteEffectiveDate
  ) {
    errorList.push({
      sectionKey: BASE_COUPON_PAGE_ANCHOR_KEY.validPeriod.sectionKey,
      name: `${prefix}absoluteExpiryDate`,
      message: CouponErrorFields.endDatetime.message,
    });
  }
  if (
    validPeriodType === VALID_PERIOD_TYPE.RELATIVE &&
    !numberOfDaysToExpireAfterAcquisition
  ) {
    errorList.push({
      sectionKey: BASE_COUPON_PAGE_ANCHOR_KEY.validPeriod.sectionKey,
      name: `${prefix}numberOfDaysToExpireAfterAcquisition`,
      message: CouponErrorFields.relativeDay.message,
    });
  }
  if (mediumType === COUPON_SET_MEDIUM.ONLINE) {
    errorList = [...errorList, ...onlineCouponValidate({ getValues, prefix })]
  } else if (mediumType === COUPON_SET_MEDIUM.OFFLINE) {
    errorList = [...errorList, ...offlineCouponValidate({ getValues, prefix })]
  } else if (mediumType === COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE) {
    if (isDifferentCodeForOnlineOffline) {
      errorList = [...errorList,
      ...onlineCouponValidate({ getValues, prefix }),
      ...offlineCouponValidate({ getValues, prefix })
      ]
    } else {
      errorList = [...errorList, ...onlineAndOfflineValidate({ getValues, prefix })]
    }
  }
  return errorList
}

export const couponTemplateAdditionalDataValidate = ({
  getValues,
  prefix = "",
}) => {
  const [
    additionalData,
  ] = getValues([
    `${prefix}additionalData`,
  ]);

  let errorList = [];

  for (const [index, additionalItem] of (additionalData || []).entries()) {
    if (additionalItem.title || !additionalItem.value) {
      continue
    }
    errorList.push({
      sectionKey: BASE_COUPON_PAGE_ANCHOR_KEY.additionalData.sectionKey,
      name: `${prefix}additionalData.${index}.title`,
      message: CouponErrorFields.additionalDataTitle.message,
    });
  }
  return errorList
}

export const couponValidateV2 = ({
  getValues,
  setError,
  clearErrors,
}) => {
  clearErrors();

  const [
    stores,
  ] = getValues([
    'selectedStores',
  ]);
  const mediumType = getCouponSetMedium(stores);

  let errorList = [
    ...couponBaseInfoValidate({
      getValues,
    }),
    ...couponCodeValidate({ getValues, mediumType }),
    ...couponTemplateAdditionalDataValidate({ getValues }),
  ];

  if (
    (!stores || stores?.length <= 0)
  ) {
    errorList.push({
      sectionKey: BASE_COUPON_PAGE_ANCHOR_KEY.applicableStores.sectionKey,
      name: 'selectedStores',
      message: CouponErrorFields.applicationStore.message,
    });
  }

  errorList.forEach((error) => {
    setError(error.name, {
      type: 'manual',
      message: error.message,
    });
  });

  return !errorList.length;
};

function secondStepValidate({ getValues, setError, extra }) {
  const [
    type,
    mediumType,
    selectedBrand,
    shouldUseInStore,
    customerOnlineOfflineSelectionBehavior,
    selectedStores,
    ticketStore,
  ] = getValues([
    'type',
    'mediumType',
    'selectedBrand',
    'shouldBeUsedInStores',
    'customerOnlineOfflineSelectionBehavior',
    'selectedStores',
    'ticketStore',
  ]);
  const errorList = couponBaseInfoValidate({
    getValues,
    prefix: "",
    type,
  })

  if (!selectedBrand && type === COUPON_TYPES.TICKET) {
    errorList.push({
      name: 'selectedBrand',
      message: CouponErrorFields.brand.message,
    });
  }
  console.log('@59', selectedStores, selectedBrand, shouldUseInStore);
  if (type === COUPON_TYPES.NORMAL) {
    // if (shouldUseInStore) {
    //   // if (selectedStores.length === 0) {
    //   //   console.log('@61');
    //   //   errorList.push({
    //   //     name: 'selectedStores',
    //   //     message: CouponErrorFields.applicationStore.message,
    //   //   });
    //   // }
    //   if (!customerStoreSelectionBehavior) {
    //     errorList.push({
    //       name: 'customerStoreSelectionBehavior',
    //       message: CouponErrorFields.customerStoreSelectionBehavior.message,
    //     });
    //   }
    // }
    if (
      !shouldUseInStore &&
      mediumType === COUPON_SET_MEDIUM.ONLIEN_OR_OFFLINE
    ) {
      if (!customerOnlineOfflineSelectionBehavior) {
        errorList.push({
          name: 'customerOnlineOfflineSelectionBehavior',
          message:
            CouponErrorFields.customerOnlineOfflineSelectionBehavior.message,
        });
      }
    }
  }
  if (type === COUPON_TYPES.TICKET && !ticketStore?.pk) {
    errorList.push({
      name: 'ticketStore',
      message: CouponErrorFields.applicationStore.message,
    });
  }

  if (
    type === COUPON_TYPES.NORMAL &&
    (!extra?.couponStores?.stores || extra?.couponStores?.stores.length <= 0)
  ) {
    errorList.push({
      name: 'selectedStores',
      message: CouponErrorFields.applicationStore.message,
    });
  }

  errorList.forEach((error) => {
    setError(error.name, {
      type: 'manual',
      message: error.message,
    });
  });
  return !errorList.length;
}

function thirdStepValidate({ getValues, setError }) {
  const [
    mediumType,
    additionalData,
  ] = getValues([
    'mediumType',
    'additionalData',
  ]);
  let errorList = couponCodeValidate({ getValues, mediumType })

  for (const [index, additionalItem] of (additionalData || []).entries()) {
    if (additionalItem.title || !additionalItem.value) {
      continue
    }
    errorList.push({
      name: `additionalData.${index}.title`,
      message: CouponErrorFields.additionalDataTitle.message,
    });
  }

  errorList.forEach((error) => {
    setError(error.name, {
      type: 'manual',
      message: error.message,
    });
  });
  return !errorList.length;
}

export function validate({
  getValues,
  setError,
  clearErrors,
  step,
  isBack,
  extra,
}) {
  console.log('@200 couponValidate:', getValues());
  if (isBack) {
    return true;
  }
  clearErrors();
  switch (step) {
    case 0:
      const validStepOne = firstStepValidate({ getValues, setError });
      return validStepOne;
    case 1:
      const validStepTwo = secondStepValidate({ getValues, setError, extra });
      return validStepTwo;
    case 2:
      const validStepThree = thirdStepValidate({ getValues, setError });
      return validStepThree;
    default:
      const validOne = firstStepValidate({ getValues, setError });
      const validTwo = secondStepValidate({ getValues, setError });
      const validThree = thirdStepValidate({ getValues, setError });
      return validOne && validTwo && validThree;
  }
}